import React, { useEffect, useRef } from 'react';
import styles from './TabNav.module.scss';

function TabNav({ tabs, activeTab, onTabChange, actions }) {
  const tabNavRef = useRef(null);
  const activeTabRef = useRef(null);

  // Scroll to active tab when it changes
  useEffect(() => {
    if (activeTabRef.current && tabNavRef.current) {
      const tabNav = tabNavRef.current;
      const activeTabElement = activeTabRef.current;
      
      // Calculate the center position for the active tab
      const tabNavWidth = tabNav.offsetWidth;
      const activeTabWidth = activeTabElement.offsetWidth;
      const activeTabLeft = activeTabElement.offsetLeft;
      
      // Scroll the active tab into view (centered if possible)
      const scrollPosition = activeTabLeft - (tabNavWidth / 2) + (activeTabWidth / 2);
      
      // Smooth scroll to the position
      tabNav.scrollTo({
        left: Math.max(0, scrollPosition),
        behavior: 'smooth'
      });
    }
  }, [activeTab]);

  return (
    <div className={styles.tabNavContainer}>
      <nav className={styles.tabNav} ref={tabNavRef}>
        {tabs.map(tab => (
          <button
            key={tab}
            className={`${styles.tabButton} ${activeTab === tab ? styles.active : ''}`}
            onClick={() => onTabChange(tab)}
            ref={activeTab === tab ? activeTabRef : null}
          >
            {tab}
          </button>
        ))}
      </nav>
      {actions && <div className={styles.tabActions}>{actions}</div>}
    </div>
  );
}

export default TabNav; 